import qualityEventsHelpers from '../quality-events.helpers';

type Extra = Record<string, unknown>;
export type MetricDashboardView =
    | 'overview'
    | 'salesAndDownloads:analysis'
    | 'salesAndDownloads:reports'
    | 'performance:overview'
    | 'performance:compare'
    | 'traffic';
const type = 'metricsDashboardAction';

export const METRICS_DASHBOARD_EVENTS = {
    showChart(source: MetricDashboardView, extra: Extra) {
        qualityEventsHelpers.track({
            type,
            source,
            extra: JSON.stringify({
                action: 'showChart',
                ...extra
            })
        });
    },
    showTopMaterialsStats(tab: string) {
        qualityEventsHelpers.track({
            type,
            source: 'overview',
            extra: JSON.stringify({
                action: `show_${tab}`
            })
        });
    },
    openTab(view: MetricDashboardView, extra = {}) {
        qualityEventsHelpers.track({
            type,
            source: view,
            extra: JSON.stringify({
                action: 'viewTab',
                ...extra
            })
        });
    },
    popupViewed() {
        qualityEventsHelpers.track({
            type: 'author_dashboard_popup_viewed'
        });
    },
    popupClosed() {
        qualityEventsHelpers.track({
            type: 'author_dashboard_popup_closed'
        });
    },
    popupCtaClicked() {
        qualityEventsHelpers.track({
            type: 'author_dashboard_popup_cta_clicked'
        });
    },
    popupHelpcenterClicked() {
        qualityEventsHelpers.track({
            type: 'author_dashboard_popup_helpcenter_clicked'
        });
    }
};
